import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';

import ActiveAlertsBanner from '../Events/ActiveAlertsBanner';
import AlertAndDmTable from '../Events/AlertAndDmTable';
import AlertCard from '../Events/AlertCard';
import MobileFiltersModal from '../Events/MobileFiltersModal';
import PaginationFooter from '../PaginationFooter';
import { STICKY_OVERRIDE } from '../../Styles/Z-INDEX';

export default function AssetDM1FaultsDisplay(props) {
  const {
    asset,
    tab,
    data,
    dataLoading,
    page,
    pages,
    handlePageChange,
    toggleMobileFilters,
    showMobileFilters,
    error,
  } = props;
  return (
    <>
      <button
        className="d-lg-none btn btn-link p-0 text-decoration-none shadow-none position-absolute"
        onClick={() => toggleMobileFilters(!showMobileFilters)}
        style={{ right: '0.5rem', top: '-5.7rem', zIndex: STICKY_OVERRIDE }}
      >
        <FontAwesomeIcon
          className="text-brand-primary"
          icon={faSlidersH}
          size="lg"
        />
      </button>
      <div className="outer-dm1-component-wrapper position-absolute container-fluid h-100 pt-3 pt-lg-0 rounded-lg d-flex flex-column">
        {asset.orgID ? (
          <ActiveAlertsBanner
            {...props}
            assetView
            orgID={asset.orgID}
            gatewayIdFilter={asset._id}
          />
        ) : null}
        <div className="d-none d-lg-flex row flex-fill">
          <AlertAndDmTable {...props} assetView />
        </div>
        <div className="d-lg-none row flex-fill position-relative">
          <div className="position-absolute h-100 w-100 overflow-auto">
            {data.map((a) => (
              <AlertCard key={a.Id} alert={a} tab={tab} assetView />
            ))}
          </div>
        </div>
        <div className="row justify-content-end">
          <p className="col-12 text-danger three-quarter-text text-right">
            {error}
          </p>
        </div>
        <div className="py-1 py-lg-2">
          <PaginationFooter
            handlePageChange={handlePageChange}
            page={page}
            pages={pages}
            rowsLength={data?.length}
            rowsLoading={dataLoading}
          />
        </div>
        <MobileFiltersModal
          isOpen={showMobileFilters}
          toggleModal={toggleMobileFilters}
          assetView
          {...props}
        />
        <style jsx>{`
          @media (min-width: 992px) {
            .outer-dm1-component-wrapper {
              background-color: white;
            }
            .table-container {
              height: calc(100% - 7rem);
              overflow-y: scroll;
            }
          }
        `}</style>
      </div>
    </>
  );
}

AssetDM1FaultsDisplay.propTypes = {
  asset: PropTypes.object,
  data: PropTypes.arrayOf(PropTypes.object),
  dataLoading: PropTypes.bool,
  error: PropTypes.string,
  fmiFilterRef: PropTypes.object,
  handleDmFilterSelected: PropTypes.func,
  handlePageChange: PropTypes.func,
  handleSortClick: PropTypes.func,
  handleStatusSelected: PropTypes.func,
  page: PropTypes.number,
  pages: PropTypes.number,
  saFilterRef: PropTypes.object,
  selectedStatus: PropTypes.oneOf(['positive', 'negative', 'all']),
  setError: PropTypes.func,
  showMobileFilters: PropTypes.bool,
  sort: PropTypes.shape({
    by: PropTypes.oneOf(['TriggeredAt', 'DetectedAt']),
    direction: PropTypes.oneOf(['ASC', 'DESC']),
  }),
  spnFilterRef: PropTypes.object,
  tab: PropTypes.oneOf(['dm1']),
  toggleMobileFilters: PropTypes.func,
};

AssetDM1FaultsDisplay.defaultProps = { asset: {}, data: [] };
